import React, { useContext, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import useStyles from "./TrackingClasses";
import moment from "moment";
import palette from "../../theme/palette";
import SnackBarComp from "../../components/snackBar";
import AddRefQuesModal from "../tracker/addRefQuesModal";
import { Typography } from "@mui/material";
import { UserTypeContext } from "../../context/userStatus";
import { TRACKING_CONST } from "./constants";
import { setTrackingState } from "../../store/actions/trackerAction";
import { TrackingContext } from "../../context/userTracking";
import { trackingService } from "../../services/tracking";
import { UpdateUserLevelModal } from "../../interfaces/outcomeModal";
import {
  addCategoryJourneyAction,
  addJourneyAction,
  setToturialStepGlobal,
} from "../../store/actions/userTypeAction";
import { isFirefox } from "../../utils/staticDataJson";
import DoubleClickHandler from "../tracker/DoubleClickHandler";
import HTMLTooltip from "../../components/HTMLTooltip";
import { pxToRem } from "../../theme/typography";
import { TRACKING_EVENT_NAMES, TUTORIAL_STEPS } from "../TutorialsFlow/tutorialsSteps";
const IconPersonalReflective = ({
  item,
  date,
  callservice,
  style = {},
  isExpand,
  category = {} as any,
  calendar,
  journyList,
  setShowOutcomeInput,
  setShowInfluenceInput,
  setOutcomeId,
  setInfluenceId,
  setRefId,
  refId,
  isLast = false,
  restricted = false,
  className = "",
  showHighlight = false
}) => {
  const classes = useStyles();
  const textareaRef = useRef<HTMLTextAreaElement>();
  const { state: outcomeState, dispatch: UserTypeDispatch } =
    useContext(UserTypeContext);
  const { state: ITrackerState, dispatch: trackingDispatch } =
    useContext(TrackingContext);
  const formatedDate = moment(date).format("MM-DD-YYYY");
  const clickCondition = moment(date).isBetween(
    moment().subtract(8, "year"),
    moment().add(1, 'day').startOf('day')
  );
  useEffect(() => {
    if (isLast && ITrackerState.showLoader) {
      trackingDispatch(
        setTrackingState({
          showLoader: false,
          isLastAlreadyLoaded: true,
        })
      );
    }
  }, [isLast, ITrackerState.showLoader]);

  const [showSnakbar, setShowSnakbar] = useState(false);
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [msgType, setMsgType] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [openRefQuesModal, setOpenRefQuesModal] = useState(false);
  const [showNotesInput, setShowNotesInput] = useState(false);
  const [questionValue, setQuestionValue] = useState<any>("");
  const [questionArr, setQuestionArr] = useState([]);
  const { reflectiveResponses = [] } = item;
  const heightObj = TRACKING_CONST.EXPAND_HEIGHT;
  const renderToNextInput = (e, categoryId, id, isAddCase = false) => {
    if (outcomeState.tutorialVisible) {
      return
    }
    if (!outcomeState.isPersonal) {
      const foundIndex = outcomeState?.reflectiveList.findIndex(
        (it) => it._id === id
      );
      if (foundIndex > -1) {
        if (outcomeState?.reflectiveList[foundIndex + 1]?.skipMetric) {
          renderToNextInput(
            e,
            categoryId,
            outcomeState?.reflectiveList[foundIndex + 1]?._id
          );
        } else {
          const foundZeroInfluence =
            outcomeState?.reflectiveList[foundIndex + 1]?._id;
          if (foundZeroInfluence) {
            const date = moment(formatedDate, "mm-DD-yyyy").format(
              "mm-DD-yyyy"
            );
            const foundElement = document.getElementById(
              date + "_" + foundZeroInfluence
            );
            if (foundElement) {
              setRefId(
                outcomeState?.reflectiveList[foundIndex + 1]?.reflectiveId
              );
              foundElement.click();
            }
          }
        }
      }
    } else {
      if (item.categoryName !== "Other") {
        const foundCategory = journyList.find(
          (it) => it.categoryId === categoryId
        );
        if (foundCategory && foundCategory.alls && foundCategory.alls.length) {
          const findIndexOfEl = foundCategory.alls.findIndex(
            (it) => it._id === id
          );
          let isLast = false
          if (findIndexOfEl === foundCategory.alls.length - 1) {
            isLast = true
          }
          if (isLast) {
            const foundCategoryIndex = journyList.findIndex(
              (it) => it.categoryId === categoryId
            )
            if (foundCategoryIndex > -1 && journyList[foundCategoryIndex + 1]?.categoryId && journyList[foundCategoryIndex + 1]?.alls && journyList[foundCategoryIndex + 1]?.alls?.length) {
              if (journyList[foundCategoryIndex + 1]?.alls[0].skipMetric) {
                renderToNextInput(
                  e,
                  journyList[foundCategoryIndex + 1]?.categoryId,
                  journyList[foundCategoryIndex + 1]?.alls[0]._id,
                  isAddCase
                );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date + "_" + journyList[foundCategoryIndex + 1]?.alls[0]._id
                );
                if (foundElement) {
                  if (journyList[foundCategoryIndex + 1]?.alls[0].outcomeId) {
                    setShowOutcomeInput(true);
                    setOutcomeId(
                      journyList[foundCategoryIndex + 1]?.alls[0].outcomeId
                    );
                    foundElement.click();
                  }
                  if (journyList[foundCategoryIndex + 1]?.alls[0].influenceId) {
                    setShowInfluenceInput(true);
                    setInfluenceId(
                      journyList[foundCategoryIndex + 1]?.alls[0].influenceId
                    );
                    foundElement.click();
                  }
                  if (
                    journyList[foundCategoryIndex + 1]?.alls[0].reflectiveId &&
                    isAddCase
                  ) {
                    setRefId(
                      journyList[foundCategoryIndex + 1]?.alls[0].reflectiveId
                    );
                    foundElement.click();
                  }
                }
              }
            }
          } else if (findIndexOfEl > -1) {
            // // down arrow handle
            if (
              (e.key === "Enter" || Number(e.keyCode) === 40) &&
              foundCategory.alls[findIndexOfEl + 1] &&
              foundCategory.alls[findIndexOfEl + 1]._id
            ) {
              if (foundCategory.alls[findIndexOfEl + 1]?.skipMetric) {
                renderToNextInput(
                  e,
                  categoryId,
                  foundCategory.alls[findIndexOfEl + 1]._id
                );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date + "_" + foundCategory.alls[findIndexOfEl + 1]._id
                );
                if (foundElement) {
                  if (foundCategory.alls[findIndexOfEl + 1].outcomeId) {
                    setShowOutcomeInput(true);
                    setOutcomeId(
                      foundCategory.alls[findIndexOfEl + 1].outcomeId
                    );
                    foundElement.click();
                  }
                  if (foundCategory.alls[findIndexOfEl + 1].influenceId) {
                    setShowInfluenceInput(true);
                    setInfluenceId(
                      foundCategory.alls[findIndexOfEl + 1].influenceId
                    );
                    foundElement.click();
                  }
                  if (
                    foundCategory.alls[findIndexOfEl + 1].reflectiveId &&
                    isAddCase
                  ) {
                    setRefId(
                      foundCategory.alls[findIndexOfEl + 1].reflectiveId
                    );
                    foundElement.click();
                  }
                }
              }
            } else if (e.key === "Enter" || Number(e.keyCode) == 40) {
              const foundCategoryIndex = journyList.findIndex(
                (it) => it.categoryId === categoryId
              );
              if (foundCategoryIndex > -1) {
                if (journyList[foundCategoryIndex + 1].name === "Other") {
                  if (
                    journyList[foundCategoryIndex + 1].outcomes &&
                    journyList[foundCategoryIndex + 1].outcomes.length
                  ) {
                    if (
                      journyList[foundCategoryIndex + 1].outcomes[0]?.skipMetric
                    ) {
                      renderToNextInput(
                        e,
                        categoryId,
                        journyList[foundCategoryIndex + 1].outcomes[0]._id
                      );
                    } else {
                      const date = moment(formatedDate, "mm-DD-yyyy").format(
                        "mm-DD-yyyy"
                      );
                      const foundElement = document.getElementById(
                        date +
                        "_" +
                        journyList[foundCategoryIndex + 1].outcomes[0]._id
                      );
                      if (foundElement) {
                        foundElement.click();
                      }
                    }
                  } else if (
                    journyList[foundCategoryIndex + 1].influences &&
                    journyList[foundCategoryIndex + 1].influences.length
                  ) {
                    if (
                      journyList[foundCategoryIndex + 1].influences[0]
                        ?.skipMetric
                    ) {
                      renderToNextInput(
                        e,
                        categoryId,
                        journyList[foundCategoryIndex + 1].influences[0]._id
                      );
                    } else {
                      const date = moment(formatedDate, "mm-DD-yyyy").format(
                        "mm-DD-yyyy"
                      );
                      const foundElement = document.getElementById(
                        date +
                        "_" +
                        journyList[foundCategoryIndex + 1].influences[0]._id
                      );
                      if (foundElement) {
                        foundElement.click();
                      }
                    }
                  }
                } else {
                  if (
                    journyList[foundCategoryIndex + 1] &&
                    journyList[foundCategoryIndex + 1].alls &&
                    journyList[foundCategoryIndex + 1].alls.length
                  ) {
                    if (
                      journyList[foundCategoryIndex + 1].alls[0]?.skipMetric
                    ) {
                      renderToNextInput(
                        e,
                        categoryId,
                        journyList[foundCategoryIndex + 1].alls[0]._id
                      );
                    } else {
                      const date = moment(formatedDate, "mm-DD-yyyy").format(
                        "mm-DD-yyyy"
                      );
                      const foundElement = document.getElementById(
                        date +
                        "_" +
                        journyList[foundCategoryIndex + 1].alls[0]._id
                      );
                      if (foundElement) {
                        if (foundCategory.alls[findIndexOfEl + 1].outcomeId) {
                          setOutcomeId(
                            foundCategory.alls[findIndexOfEl + 1].outcomeId
                          );
                        }
                        if (foundCategory.alls[findIndexOfEl + 1].influenceId) {
                          setInfluenceId(
                            foundCategory.alls[findIndexOfEl + 1].influenceId
                          );
                        }
                        foundElement.click();
                      }
                    }
                  }
                }
              }
            }
            // // up arrow key
            if (
              Number(e.keyCode) === 38 &&
              foundCategory.alls[findIndexOfEl - 1] &&
              foundCategory.alls[findIndexOfEl - 1]._id
            ) {
              if (foundCategory.alls[findIndexOfEl - 1]?.skipMetric) {
                renderToNextInput(
                  e,
                  categoryId,
                  foundCategory.alls[findIndexOfEl - 1]._id
                );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date + "_" + foundCategory.alls[findIndexOfEl - 1]._id
                );
                if (foundElement) {
                  foundElement.click();
                }
              }
            }
            //right side arrow keys
            if (Number(e.keyCode) === 39) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .add(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + id);
              if (foundElement) {
                foundElement.click();
              }
            }
            //left side arrow keys
            if (Number(e.keyCode) === 37) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .subtract(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + id);
              if (foundElement) {
                foundElement.click();
              }
            }
          }
        }
      } else {
        const foundOther = (journyList || []).findIndex(
          (it) => it.name === "Other"
        );
        if (foundOther > -1) {
          const outcomeFound = journyList[foundOther].reflectives.findIndex(
            (it) => it._id === id
          );
          if (outcomeFound > -1) {
            // // down arrow handle
            if (
              (e.key === "Enter" || Number(e.keyCode) === 40) &&
              journyList[foundOther].reflectives[outcomeFound + 1] &&
              journyList[foundOther].reflectives[outcomeFound + 1]._id
            ) {
              if (
                journyList[foundOther].reflectives[outcomeFound + 1]?.skipMetric
              ) {
                // renderToNextInput(
                //   e,
                //   categoryId,
                //   journyList[foundOther].reflectives[outcomeFound + 1]._id
                // );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date +
                  "_" +
                  journyList[foundOther].reflectives[outcomeFound + 1]._id
                );
                if (foundElement) {
                  // foundElement.click()
                }
              }
            } else if (e.key === "Enter" || Number(e.keyCode) === 40) {
              if (journyList[foundOther].reflectives[0]?.skipMetric) {
                // renderToNextInput(
                //   e,
                //   categoryId,
                //   journyList[foundOther].reflectives[0]._id
                // );
              } else {
                const foundZeroInfluence =
                  journyList[foundOther].reflectives[0]?._id;
                if (foundZeroInfluence) {
                  const date = moment(formatedDate, "mm-DD-yyyy").format(
                    "mm-DD-yyyy"
                  );
                  const foundElement = document.getElementById(
                    date + "_" + journyList[foundOther].reflectives[0]._id
                  );
                  if (foundElement) {
                    // foundElement.click()
                  }
                }
              }
            }
            // // up arrow key
            if (
              Number(e.keyCode) === 38 &&
              journyList[foundOther].outcomes[outcomeFound - 1] &&
              journyList[foundOther].outcomes[outcomeFound - 1]._id
            ) {
              if (
                journyList[foundOther].outcomes[outcomeFound - 1]?.skipMetric
              ) {
                renderToNextInput(
                  e,
                  categoryId,
                  journyList[foundOther].outcomes[outcomeFound - 1]._id
                );
              } else {
                const date = moment(formatedDate, "mm-DD-yyyy").format(
                  "mm-DD-yyyy"
                );
                const foundElement = document.getElementById(
                  date +
                  "_" +
                  journyList[foundOther].outcomes[outcomeFound - 1]._id
                );
                if (foundElement) {
                  foundElement.click();
                }
              }
            } else if (Number(e.keyCode) === 38) {
              const foundOther = (journyList || []).findIndex(
                (it) => it.name === "Other"
              );
              if (foundOther > -1) {
                if (
                  journyList[foundOther - 1] &&
                  journyList[foundOther - 1].alls &&
                  journyList[foundOther - 1].alls.length
                ) {
                  if (
                    journyList[foundOther - 1].alls[
                      journyList[foundOther - 1].alls.length - 1
                    ]?.skipMetric
                  ) {
                    renderToNextInput(
                      e,
                      categoryId,
                      journyList[foundOther - 1].alls[
                        journyList[foundOther - 1].alls.length - 1
                      ]._id
                    );
                  } else {
                    const date = moment(formatedDate, "mm-DD-yyyy").format(
                      "mm-DD-yyyy"
                    );
                    const foundElement = document.getElementById(
                      date +
                      "_" +
                      journyList[foundOther - 1].alls[
                        journyList[foundOther - 1].alls.length - 1
                      ]._id
                    );
                    if (foundElement) {
                      foundElement.click();
                    }
                  }
                }
              }
            }

            //right side arrow keys
            if (Number(e.keyCode) === 39) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .add(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + id);
              if (foundElement) {
                foundElement.click();
              }
            }
            //left side arrow keys
            if (Number(e.keyCode) === 37) {
              const date = moment(formatedDate, "mm-DD-yyyy")
                .subtract(1, "day")
                .format("mm-DD-yyyy");
              const foundElement = document.getElementById(date + "_" + id);
              if (foundElement) {
                foundElement.click();
              }
            }
          } else {
          }
        }
      }
    }
  };
  React.useLayoutEffect(() => {
    if (!textareaRef.current) return;
    if (textareaRef.current) {
      // Reset height - important to shrink on delete
      textareaRef.current.style.height = "inherit";
      // Set height
      textareaRef.current.style.height = `${Math.max(
        textareaRef.current.scrollHeight,
        32
      )}px`;
    }
  }, [showNotesInput, questionValue]);
  React.useLayoutEffect(() => {
    if (!textareaRef.current) return;
    if (textareaRef.current) {
      textareaRef.current.focus();
      textareaRef.current.setSelectionRange(
        textareaRef.current.value.length,
        textareaRef.current.value.length
      );
    }
  }, [showNotesInput]);
  const handleBlurInputArea = (type, e: any, mouseOut, id) => {
    if (mouseOut) {
      setShowNotesInput(false);
    }
    if (
      Number(e.keyCode) === 37 ||
      Number(e.keyCode) === 38 ||
      Number(e.keyCode) === 39 ||
      Number(e.keyCode) === 40 ||
      mouseOut
    ) {
      createRefResponse();
    }
  };
  const proceedTutorialToNextStep = (step = localStorage.getItem("tutorialStep")) => {
    if (outcomeState.tutorialVisible) {

      const foundStepIndex = TUTORIAL_STEPS.findIndex(it => it.step === Number(`${(Number(step) + 1)}`))
      if (foundStepIndex > -1) {
        if (TUTORIAL_STEPS[foundStepIndex].skip) {
          proceedTutorialToNextStep(`${Number(step) + 1}`)
        } else {
          localStorage.setItem("tutorialStep", `${(Number(step) + 1)}`)
          UserTypeDispatch(setToturialStepGlobal(Number(`${(Number(step) + 1)}`)))
        }
      } else {
        localStorage.setItem("tutorialStep", `${(Number(step) + 1)}`)
        UserTypeDispatch(setToturialStepGlobal(Number(`${(Number(step) + 1)}`)))
      }
    }
  }
  const trackEve = () => {
    trackingService.signupCompletedBoarding(outcomeState.token, {
      mixpanel_type: TRACKING_EVENT_NAMES.DAY_1_IN_APP_QUESTION_ENTRY
    });
  }
  const pushIntoData = (outcomeCreateData) => {
    const journeyCategoryList = [...(outcomeState?.journeyCategoryList || [])];
    const foundOutcome = (journeyCategoryList || []).findIndex(
      (it) =>
        it.reflectiveIds &&
        it.reflectiveIds.includes(outcomeCreateData.reflectiveId)
    );
    if (foundOutcome > -1) {
      if (
        journeyCategoryList[foundOutcome].alls &&
        journeyCategoryList[foundOutcome].alls.length
      ) {
        const foundIndex = journeyCategoryList[foundOutcome].alls.findIndex(
          (it) => it.reflectiveId === outcomeCreateData.reflectiveId
        );
        if (foundIndex > -1) {
          if (
            journeyCategoryList[foundOutcome].alls[foundIndex]
              .reflectiveResponses &&
            journeyCategoryList[foundOutcome].alls[foundIndex]
              .reflectiveResponses.length
          ) {
            const foundDateValue = journeyCategoryList[foundOutcome].alls[
              foundIndex
            ].reflectiveResponses.findIndex(
              (it) => it._id.date === outcomeCreateData.date
            );
            if (foundDateValue > -1) {
              journeyCategoryList[foundOutcome].alls[
                foundIndex
              ].reflectiveResponses[foundDateValue] = {
                _id: {
                  ...outcomeCreateData,
                },
              };
            } else {
              journeyCategoryList[foundOutcome].alls[
                foundIndex
              ].reflectiveResponses.push({
                _id: {
                  ...outcomeCreateData,
                },
              });
            }
          } else {
            journeyCategoryList[foundOutcome].alls[
              foundIndex
            ].reflectiveResponses = [
                {
                  _id: {
                    ...outcomeCreateData,
                  },
                },
              ];
          }
          UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
        }
      }
    } else {
      const foundOther = (journeyCategoryList || []).findIndex(
        (it) => it.name === "Other"
      );
      if (foundOther > -1) {
        const outcomeFound = journeyCategoryList[
          foundOther
        ].reflectives.findIndex(
          (it) => it.reflectiveId === outcomeCreateData.reflectiveId
        );
        if (outcomeFound > -1) {
          if (
            journeyCategoryList[foundOther].reflectives[outcomeFound]
              .reflectiveResponses &&
            journeyCategoryList[foundOther].reflectives[outcomeFound]
              .reflectiveResponses.length
          ) {
            const foundDateValue = journeyCategoryList[foundOther].reflectives[
              outcomeFound
            ].reflectiveResponses.findIndex(
              (it) => it._id.date === outcomeCreateData.date
            );
            if (foundDateValue > -1) {
              journeyCategoryList[foundOther].reflectives[
                outcomeFound
              ].reflectiveResponses[foundDateValue] = {
                _id: {
                  ...outcomeCreateData,
                },
              };
            } else {
              journeyCategoryList[foundOther].reflectives[
                outcomeFound
              ].reflectiveResponses.push({
                _id: {
                  ...outcomeCreateData,
                },
              });
            }
          } else {
            journeyCategoryList[foundOther].reflectives[
              outcomeFound
            ].reflectiveResponses = [
                {
                  _id: {
                    ...outcomeCreateData,
                  },
                },
              ];
          }
          UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));
        }
      }
    }
    const foundOutcomeDef = (outcomeState?.reflectiveList || []).find(
      (it) => it.reflectiveId === outcomeCreateData.reflectiveId
    );
    if (foundOutcomeDef) {
      const journyList = { ...(outcomeState?.journeyList || {}) } as any;
      const foundDateItemIcon = journyList.reflective_data.findIndex(
        (it) =>
          it.reflectiveId === outcomeCreateData.reflectiveId &&
          it?.date === outcomeCreateData.date
      );
      if (foundDateItemIcon > -1) {
        journyList.reflective_data[foundDateItemIcon] = {
          ...foundOutcomeDef,
          ...outcomeCreateData,
        };
      } else {
        journyList.reflective_data.push({
          ...foundOutcomeDef,
          ...outcomeCreateData,
        } as any);
      }
      UserTypeDispatch(addJourneyAction(journyList as any));
    }
  };
  const createRefResponse = () => {
    let bodyData = {
      reflectiveId: refId,
      answers:
        questionValue === "" || questionValue === "\n"
          ? questionArr
            .filter((it) => it && it !== "\n")
            .join("\n")
            .split("\n")
          : [...questionArr, questionValue]
            .filter((it) => it && it !== "\n")
            .join("\n")
            .split("\n"),
      date: formatedDate,
    };
    bodyData.answers = bodyData.answers.filter((it) => it && it !== "\n");
    pushIntoData(bodyData);
    trackingService
      .refQuesCreate(outcomeState.token, bodyData)
      .then((data: UpdateUserLevelModal) => { })
      .catch((error) => {
        setShowSnakbar(true);
        setSnakbarMsg(
          error?.response?.data?.description
            ? error?.response?.data?.description
            : error?.message
        );
        setMsgType("error");
      });
  };
  const found =
    reflectiveResponses && reflectiveResponses.length > 0
      ? reflectiveResponses.find((journey) =>
        outcomeState.isPersonal
          ? journey?._id?.date === formatedDate && journey?._id?.answers?.length > 0
          : journey?.date === formatedDate && journey?.answers?.length > 0
      )
      : undefined;
  return (
    <td
      className={clsx(
        classes.cell,
        classes.borderBottom,
        isExpand ? classes.iconExpand : "",
        className
      )}
      style={{
        position: "relative",
        height: isFirefox ? "100%" : "inherit",
        ...style,
      }}
      key={item._id}
    >
      <SnackBarComp
        showSnakbar={showSnakbar}
        handleCloseSnakbar={() => {
          setShowSnakbar(false);
        }}
        snakbarMsg={snakbarMsg}
        type={msgType ? msgType : "info"}
      />
      <div
        style={
          isExpand
            ? {
              height: "100%",
            }
            : {
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }
        }
      >
        <div
          className={
            moment(calendar[calendar.length - 1]).format("MM-DD-YYYY") ===
              formatedDate
              ? classes.iconInnerWithoutAfter
              : classes.iconInner
          }
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: isExpand ? "flex-start" : "center",
            flexBasis: "100%",
          }}

        >

          <span className={showHighlight ? classes.addOutlineIconTutorial : classes.addOutlineIcon}>
            <HTMLTooltip
              placement="right"
              customIcon={
                <div>
                  {found ? (
                    <DoubleClickHandler
                      key={item._id}
                      id={formatedDate + "_" + item._id}
                      onClick={(outcomeState.tutorialVisible && outcomeState.tutorialStep !== 14) || restricted ? () => { } : (e) => {
                        console.log("clickCondition ref", clickCondition, item);
                        if (clickCondition) {
                          proceedTutorialToNextStep()
                          setRefId(item.reflectiveId);
                          setOpenRefQuesModal(true);
                        }
                      }}
                      onDoubleClick={restricted ? () => { } : (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (clickCondition) {
                          proceedTutorialToNextStep()
                          setRefId(item.reflectiveId);
                          setIsEdit(!found);
                          setOpenRefQuesModal(true);
                        }
                      }}

                    >
                      <div
                        className="hello"
                        key={item._id}
                      >
                        <span
                          style={{
                            backgroundColor: "var(--color-new-main)",
                            border: `1px solid ${"var(--color-new-main)"}`,
                          }}
                        >
                          <span
                            style={{
                              backgroundColor: "var(--color-new-main)",
                              borderRadius: "50%",
                              border: `1px solid ${"var(--color-new-main)"}`,
                            }}
                          ></span>
                        </span>
                      </div>
                    </DoubleClickHandler>

                  ) : item?.weekDays?.some(
                    (day) =>
                      day?.day.toLowerCase() ===
                      moment(date).format("dddd").toLowerCase() &&
                      moment(date).isBefore(moment())
                  ) ? (
                    <DoubleClickHandler
                      key={item._id}
                      id={formatedDate + "_" + item._id}
                      onClick={(outcomeState.tutorialVisible && outcomeState.tutorialStep !== 14) || restricted ? () => { } : (e) => {
                        if (clickCondition) {
                          proceedTutorialToNextStep()
                          setRefId(item.reflectiveId);
                          setOpenRefQuesModal(true);
                        }
                      }}
                      onDoubleClick={restricted ? () => { } : (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (clickCondition) {
                          proceedTutorialToNextStep()
                          setRefId(item.reflectiveId);
                          setIsEdit(!found);
                          setOpenRefQuesModal(true);
                        }
                      }}

                    >
                      <span
                        style={{
                          backgroundColor: "rgb(255, 152, 0)",
                          border: `1px solid rgb(255, 152, 0)`,
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "rgb(255, 152, 0)",
                            borderRadius: "50%",
                            border: `1px solid rgb(255, 152, 0)`,
                          }}
                        ></span>
                      </span>
                    </DoubleClickHandler>
                  ) : (
                    <DoubleClickHandler
                      key={item._id}
                      id={formatedDate + "_" + item._id}
                      onClick={(outcomeState.tutorialVisible && outcomeState.tutorialStep !== 14) || restricted ? () => { } : (e) => {
                        if (clickCondition) {
                          proceedTutorialToNextStep()
                          setRefId(item.reflectiveId);
                          setOpenRefQuesModal(true);
                        }
                      }}
                      onDoubleClick={restricted ? () => { } : (e) => {
                        console.log("answers double clicked");
                        if (clickCondition) {
                          proceedTutorialToNextStep()
                          setRefId(item.reflectiveId);
                          setIsEdit(!found);
                          setOpenRefQuesModal(true);
                        }
                      }}

                    ><span key={item._id} >
                        {showHighlight ? <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.00118 0.200012C6.45848 0.200012 4.95043 0.657474 3.66773 1.51455C2.38502 2.37162 1.38528 3.58982 0.794915 5.01508C0.204551 6.44035 0.0500855 8.00867 0.35105 9.52172C0.652015 11.0348 1.39489 12.4246 2.48574 13.5154C3.57659 14.6063 4.96642 15.3492 6.47947 15.6501C7.99252 15.9511 9.56084 15.7966 10.9861 15.2063C12.4114 14.6159 13.6296 13.6162 14.4866 12.3335C15.3437 11.0508 15.8012 9.54271 15.8012 8.00001C15.7986 5.93212 14.976 3.94965 13.5138 2.48743C12.0515 1.0252 10.0691 0.202592 8.00118 0.200012ZM11.0012 8.60001H8.60118V11C8.60118 11.1591 8.53796 11.3118 8.42544 11.4243C8.31292 11.5368 8.16031 11.6 8.00118 11.6C7.84205 11.6 7.68943 11.5368 7.57691 11.4243C7.46439 11.3118 7.40118 11.1591 7.40118 11V8.60001H5.00118C4.84205 8.60001 4.68943 8.5368 4.57691 8.42428C4.46439 8.31176 4.40118 8.15914 4.40118 8.00001C4.40118 7.84088 4.46439 7.68827 4.57691 7.57575C4.68943 7.46323 4.84205 7.40001 5.00118 7.40001H7.40118V5.00001C7.40118 4.84088 7.46439 4.68827 7.57691 4.57575C7.68943 4.46323 7.84205 4.40001 8.00118 4.40001C8.16031 4.40001 8.31292 4.46323 8.42544 4.57575C8.53796 4.68827 8.60118 4.84088 8.60118 5.00001V7.40001H11.0012C11.1603 7.40001 11.3129 7.46323 11.4254 7.57575C11.538 7.68827 11.6012 7.84088 11.6012 8.00001C11.6012 8.15914 11.538 8.31176 11.4254 8.42428C11.3129 8.5368 11.1603 8.60001 11.0012 8.60001Z" fill="#FF5555" />
                        </svg> : "+"}
                      </span>
                    </DoubleClickHandler>
                  )}
                </div>
              }
              title={restricted ? "You can’t add entries on expired trial" : null}
              fontProps={{
                fontSize: `${pxToRem(12)} !important`,
              }}
              sx={{
                "& .MuiTooltip-tooltip": {
                  maxWidth: "320px",
                  background: "var(--color-border)",
                  border: "1px solid var(--color-border)",
                  "& .MuiTooltip-arrow": {
                    color: "var(--color-border)",
                    "&:before": {
                      border: "1px solid var(--color-border)",
                    }
                  }
                },
              }}
            />

          </span>
        </div>
        {isExpand ? (
          <HTMLTooltip
            placement="right"
            customIcon={<div
              style={{
                display: "flex",
                width: "176px",
                // height: length,
                padding: "12px",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "12px",
                alignSelf: "stretch",
                borderRadius: "12px",
                border: "1px solid #F3F3F3",
                background: "var(--white-background)",
                flexBasis: "100%",
                margin: "13px 8px 0px 0",
                overflowY: "auto",
                wordWrap: "break-word",
                ...heightObj,
              }}
              onClick={(outcomeState.tutorialVisible && outcomeState.tutorialStep !== 14) || restricted ? () => { } : () => {
                if (clickCondition && !showNotesInput) {
                  let notes = [];
                  if (
                    outcomeState.isPersonal &&
                    found?._id &&
                    found?._id?.answers &&
                    found?._id?.answers[0]
                  ) {
                    notes = found?._id?.answers;
                  } else if (
                    !outcomeState.isPersonal &&
                    found &&
                    found?.answers &&
                    found?.answers[0]
                  ) {
                    notes = found?.answers;
                  }
                  setQuestionValue(notes.join("\n"));
                  setShowNotesInput(true);
                  setRefId(item.reflectiveId);
                }
              }}
              onDoubleClick={restricted ? () => { } : (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (clickCondition) {
                  setRefId(item.reflectiveId);
                  setIsEdit(!found);
                  setOpenRefQuesModal(true);
                }
              }}
            >
              {showNotesInput ? (
                <textarea
                  name={item?._id}
                  autoFocus
                  ref={textareaRef}
                  value={questionValue}
                  style={{
                    width: "100%",
                    minHeight: "10px",
                    resize: "none",
                  }}
                  // defaultValue={found?.note && found?.note[0]}
                  onBlur={() => {
                    handleBlurInputArea(
                      item?.type,
                      { key: "kdksjdks", keyCode: "hdj" },
                      true,
                      item._id
                    );
                  }}
                  onChange={(e) => {
                    setQuestionValue(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    handleBlurInputArea(item?.type, e, false, item._id);
                  }}
                />
              ) : (
                <>
                  {outcomeState.isPersonal
                    ? found?._id &&
                    found?._id?.answers &&
                    found?._id?.answers[0] && (
                      <ul
                        id={
                          outcomeState.isPersonal && item._id
                            ? `${item?._id?.reflectiveId}_${formatedDate}`
                            : `${item?.reflectiveId}_${formatedDate}`
                        }
                        className={classes.notesItem}
                      >
                        {found?._id?.answers?.map(
                          (anwerItem: any, index: number) => {
                            return (
                              <li key={index}>
                                <Typography
                                  variant="h5"
                                  sx={{ color: palette.common.black }}
                                  component="span"
                                  title={anwerItem}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        anwerItem.replace(/\n/g, "<br />") ||
                                        "",
                                    }}
                                  ></span>
                                </Typography>
                              </li>
                            );
                          }
                        )}
                      </ul>
                    )
                    : found &&
                    found?.answers &&
                    found?.answers[0] && (
                      <ul
                        id={`${item?.reflectiveId}_${formatedDate}`}
                        className={classes.notesItem}
                      >
                        {found?.answers?.map(
                          (anwerItem: any, index: number) => {
                            return (
                              <li key={index}>
                                <Typography
                                  variant="h5"
                                  sx={{ color: palette.common.black }}
                                  component="span"
                                  title={anwerItem}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        anwerItem.replace(/\n/g, "<br />") ||
                                        "",
                                    }}
                                  ></span>
                                </Typography>
                              </li>
                            );
                          }
                        )}
                      </ul>
                    )}
                </>
              )}
            </div>}
            title={restricted ? "You can’t add entries on expired trial" : null}
            fontProps={{
              fontSize: `${pxToRem(12)} !important`,
            }}
            sx={{
              "& .MuiTooltip-tooltip": {
                maxWidth: "320px",
                background: "var(--color-border)",
                border: "1px solid var(--color-border)",
                "& .MuiTooltip-arrow": {
                  color: "var(--color-border)",
                  "&:before": {
                    border: "1px solid var(--color-border)",
                  }
                }
              },
            }}
          />

        ) : null}
      </div>

      {openRefQuesModal && (
        <AddRefQuesModal
          setOpenRefQuesModal={setOpenRefQuesModal}
          refId={refId}
          setShowSnakbar={setShowSnakbar}
          setSnakbarMsg={setSnakbarMsg}
          setMsgType={setMsgType}
          setRefId={setRefId}
          callService={callservice}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          journeyData={journyList}
          headerDate={formatedDate}
          pushIntoData={pushIntoData}
          item={item}
          renderToNextInput={(isAddCase = false) => {
            if(outcomeState.tutorialVisible) {
              trackEve()
            }
            proceedTutorialToNextStep()
            renderToNextInput(
              {
                key: "Enter",
              },
              category?.categoryId,
              item._id,
              isAddCase
            );
          }}
        />
      )}
    </td>
  );
};

export default IconPersonalReflective;
